import styled from "styled-components";
import { DialogContent } from "@material-ui/core";

export const StyledDialogContent = styled(DialogContent)`
  color: white;
`;
